import { Box, Tab, Tabs, useMediaQuery } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { changeTab } from "../redux/action";
import UserAccess from "../../../utils/UserAccess";
import { changeTab } from "../redux/action";

const ScratchEventLayout = ({ children }) => {
  const { palette, breakpoints } = useTheme();
  const dispatch = useDispatch();
  const { activeTab } = useSelector((state) => state.customers);
  const isSmall = useMediaQuery(breakpoints.down("sm") || breakpoints.down("xs"));
  const navigate = useNavigate();
  const SUBSCRIPTION_HISTORY_ACCESS = UserAccess("scratch_event_list");

  const handleChange = (event, newValue) => {
    dispatch(changeTab(newValue));
    if (newValue === 0) {
      navigate(`/scratch-event`);
    } else if (newValue === 1) {
      navigate(`/scratch-event-history`);
    }
  };

  useEffect(() => {
    let activation = 0;
    let currentPath = window.location.pathname;
    if (currentPath === "/scratch-event") {
      activation = 0;
    } else if (currentPath === "/scratch-event-history") {
      activation = 1;
    }
    dispatch(changeTab(activation));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const labels = useMemo(() => {
    const newLabels = [];
    newLabels.push("Scratch Event");
    if (SUBSCRIPTION_HISTORY_ACCESS) newLabels.push("Scratch Event History");

    return newLabels;
  }, [SUBSCRIPTION_HISTORY_ACCESS]);

  return (
    <Box width="100%" backgroundColor={palette.background.default} className="pageMainCardBox">
      <Tabs value={activeTab} onChange={handleChange} aria-label="invoiceTabs">
        {labels?.map((item, i) => {
          return (
            <Tab
              sx={{ fontWeight: "bold", fontSize: isSmall ? "20px" : "28px", textTransform: "capitalize" }}
              key={i}
              label={item}
            />
          );
        })}
      </Tabs>
      {children}
    </Box>
  );
};

export default ScratchEventLayout;
